import { PermissionT } from "../types";

export const enterpriseEarningsView = (permissions: PermissionT[]): boolean => {
  const p = permissions.find((permission) => permission.name === "enterprise_earnings_view");
  return !!p;
};

export default enterpriseEarningsView;
